import React from "react";
import {
  accesses,
  divisionAccesses,
  featureAccesses,
  pages,
} from "../constants";
import PrivateRoute from "../components/PrivateRoute";
import { NewClientProfile2 } from "../components/ClientProfile/NewClientProfile2";
import HelpPage from "../components/HelpPage";
import HelpPageCustomer from "../components/HelpPageCustomer";
import AboutPage from "../components/AboutPage";
import OrderHistoryBoard from "../components/Orders/OrderHistoryPage/deprecated/OrderHistoryBoard";
import OrderHistoryRework1 from "../components/Orders/OrderHistoryRework1";
import PostOrderFormRework13CityDropdown from "../components/Orders/PostOrderFormRework13CityDropdown";
import ShipmentAnalysisReport from "../components/ShipmentAnalysisReport";
import ShortageReport from "../components/Reports/Shortage Reports/ShortageReport";
import PostNewBuyoutV2 from "../components/PostNewBuyoutV2";
import { OrderActionCenter } from "../components/OrderActionCenter/OrderActionCenter";
import { determineHasAccessToCDKFeatures } from "../helpers/utilities";
import ViewClaim from "../components/ViewClaim";
import DeliveryDetailsFullRework from "../components/DeliveryDetailFullRework";
import DeliveryConcernBoard from "../components/DeliveryConcernBoard";
import ClaimBoard from "../components/ClaimBoard";
import { CDKOrderImport } from "../components/CDK/CDKOrderImport";
import CDKSettingsPage from "../components/CDK/CDKSettingsPage";
import { CDKPromoPage2 } from "../components/CDK/CDKSignupPage/CDKPromoPage";
import { CDKSignupPage2 } from "../components/CDK/CDKSignupPage/CDKSignupPage2";
import Invoices from "../components/Invoices";
import LabelViewer from "../components/LabelViewer";
import { Switch, Route } from "react-router-dom";
import { PublicTracker } from "../components/OpenFacing/PublicTracker";
import ClientDashboardPage from "../components/ClientDashboardPage";
import RedirectOnLogging from "../components/Login/RedirectOnLogging";
import NotFound from "../components/NotFound";

import ReturnRequest from "../components/ReturnRequest";
import Settings from "../components/Settings";
import ManualReturns from "../components/ManualReturns";
import { isClient } from "../services/accountService";
import { DedicatedDispatchBoard } from "../components/DedicatedDispatch/DedicatedDispatchBoard";
import OrderHistoryMode from "../components/Orders/OrderHistoryMode";
// import { OrderHistoryPagePagination } from "../components/Orders/OrderHistoryPage";
// import PaginationOrderHistoryPage from "../components/Orders/PaginationOrderHistoryPage";
import NewOrderHistoryPage from "../components/Orders/NewOrderHistoryPage";
import CODReport from "../components/Reports/CODReport";
// import { ReportGraphsTest } from "../components/Reports/Analytical/ReportGraphsTest";
// import { CDKPromoPageModern } from "../components/CDK/CDKSignupPage/CDKPromoPageModern";

export const ClientRouteManager = ({
  loading,
  setLoadingCallback,
  linkedAccounts,
  setLinkedAccounts,
  decodedClientInfo,
  pathname,
  cdkSubscriptionStatus,
  setCDKSubscriptionStatus,
  // ...props
}) => {
  // console.log(props);
  return (
    <Switch>
      {/* This is a placeholder /login route as for some reason we are redirected to "not-found" for an instant when logging in without this */}
      {/* Also need this to redirect back to mainpage if they try to access login page while logged in */}
      <Route path={pages.loginPage.url}>
        {/* <Redirect to={pages.mainPage.url} /> */}
        <RedirectOnLogging />
      </Route>

      {/* NETWORK PORTAL */}

      <PrivateRoute path={pages.clientDashboard.url}>
        <ClientDashboardPage />
      </PrivateRoute>

      <PrivateRoute
        path="/view-profile"
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        <NewClientProfile2
          setLoading={setLoadingCallback}
          accessNeeded={accesses.Base}
          linkedAccounts={linkedAccounts}
          setLinkedAccounts={setLinkedAccounts}
        />
      </PrivateRoute>

      <PrivateRoute
        path="/help"
        customersCanAccess
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        {isClient() ? <HelpPage /> : <HelpPageCustomer />}
      </PrivateRoute>

      {/* <PrivateRoute
        path="/about-page"
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        <AboutPage />
      </PrivateRoute> */}

      <PrivateRoute
        path={pages.orderHistory.url}
        accessNeeded={accesses.Base}
        customersCanAccess={true}
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        <OrderHistoryMode
          setLoading={setLoadingCallback}
          decodedClientInfo={decodedClientInfo}
        />
      </PrivateRoute>

      {/* <PrivateRoute
        path="/order-history-pagination"
        accessNeeded={accesses.Base}
        customersCanAccess={true}
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        <NewOrderHistoryPage />
      </PrivateRoute> */}

      <PrivateRoute path={pages.returnRequest.url}>
        <ReturnRequest />
      </PrivateRoute>

      <PrivateRoute path={pages.settings.url}>
        <Settings />
      </PrivateRoute>

      <PrivateRoute
        path="/manual-return"
        customersCanAccess={true}
        customerOnly
      >
        <ManualReturns />
      </PrivateRoute>

      <PrivateRoute
        path="/order-history-rework-1"
        accessNeeded={accesses.Developer}
      >
        <OrderHistoryRework1 setLoading={setLoadingCallback} />
      </PrivateRoute>

      {/* If you want to keep using the same component for post-order and modify-order, remember to update the component for both routes. */}
      <PrivateRoute
        path="/modify-order/:deliveryId"
        accessNeeded={accesses.Deltrans}
      >
        <PostOrderFormRework13CityDropdown
          // The key being the path name ensures that it re-mounts. https://stackoverflow.com/a/39150493
          //This is so when a customer is modifying one order and they paste in the url of another order, the page refreshes to update itself. I believe without specifying the key, react won't remount the component and the use effects that grab the data for the order in the url will not re run.
          key={pathname}
          setLoading={setLoadingCallback}
          loading={loading}
        />
      </PrivateRoute>

      <PrivateRoute path="/post-order" accessNeeded={accesses.Deltrans}>
        <PostOrderFormRework13CityDropdown
          setLoading={setLoadingCallback}
          loading={loading}
        />
      </PrivateRoute>
      {/* <PrivateRoute
        path="/post-return/:originalDeliveryId"
        accessNeeded={accesses.Deltrans}
      >
        <PostReturnForm setLoading={setLoadingCallback} />
      </PrivateRoute> */}
      <PrivateRoute path="/ShipmentAnalysisReport" accessNeeded={accesses.Base}>
        <ShipmentAnalysisReport setLoading={setLoadingCallback} />
      </PrivateRoute>
      <PrivateRoute path="/DiscrepancyReports" accessNeeded={accesses.Base}>
        <ShortageReport setLoading={setLoadingCallback} />
      </PrivateRoute>
      {/* <PrivateRoute path="/ReportGraphsTest" accessNeeded={accesses.Base}>
        <ReportGraphsTest setLoading={setLoadingCallback} />
      </PrivateRoute> */}
      {/* <PrivateRoute path={pages.CODReport.url} accessNeeded={accesses.Base}>
        <CODReport setLoading={setLoadingCallback} />
      </PrivateRoute> */}
      {/* <PrivateRoute path="/PostBuyoutOriginal">
         <PostBuyoutForm setLoading={setLoadingCallback} />
       </PrivateRoute> */}

      <PrivateRoute path="/PostNewBuyout" accessNeeded={accesses.Deltrans}>
        <PostNewBuyoutV2
          loading={loading}
          setLoading={setLoadingCallback}
          jwtToken={decodedClientInfo}
        />
      </PrivateRoute>

      <PrivateRoute
        path="/ActionCenter/:action/:deliveryId"
        accessNeeded={accesses.Deltrans}
        customersCanAccess={true}
      >
        <OrderActionCenter
          setLoading={setLoadingCallback}
          key={pathname} // adding this in as I think it will be useful, need to test further (key being pathname will insure component remounts when user tries to change url/copy paste a url manually) that ismael had for his modify order page
        />
      </PrivateRoute>

      <PrivateRoute
        path="/delivery-concern/:id"
        accessNeeded={accesses.Concerns}
      >
        <DeliveryDetailsFullRework setLoading={setLoadingCallback} />
      </PrivateRoute>

      <PrivateRoute path="/delivery-concern" accessNeeded={accesses.Concerns}>
        <DeliveryConcernBoard setLoading={setLoadingCallback} />
      </PrivateRoute>
      <PrivateRoute path="/claim/:id" accessNeeded={accesses.Claims}>
        <ViewClaim setLoading={setLoadingCallback} />
      </PrivateRoute>
      <PrivateRoute path="/claim" accessNeeded={accesses.Claims}>
        <ClaimBoard />
      </PrivateRoute>
      {/* <PrivateRoute path="/multi-cdk-order" accessNeeded={accesses.Developer}>
        <MultiCdkOrderContainer setLoading={setLoadingCallback} />
      </PrivateRoute>
      <PrivateRoute path="/import-cdk-order" accessNeeded={accesses.Developer}>
        <CdkImportTable setLoading={setLoadingCallback} />
      </PrivateRoute> */}
      <PrivateRoute
        path={pages.cdkOrderImport.url}
        redirectURL={pages.cdkSignUp.url}
        accessNeeded={featureAccesses.IsCdkClient}
        statusCheck={determineHasAccessToCDKFeatures(cdkSubscriptionStatus)}
      >
        <CDKOrderImport setLoading={setLoadingCallback} />
      </PrivateRoute>
      <PrivateRoute
        path="/cdk-settings"
        redirectURL={pages.cdkSignUp.url}
        accessNeeded={featureAccesses.IsCdkClient}
        statusCheck={determineHasAccessToCDKFeatures(cdkSubscriptionStatus)}
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        {/* <FieldPreferenceSettingsContainer setLoading={setLoadingCallback} />
         */}
        <CDKSettingsPage clientId={decodedClientInfo.ClientId} />
      </PrivateRoute>
      <PrivateRoute
        path={pages.cdkIntroduction.url}
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        <CDKPromoPage2
          decodedJWT={decodedClientInfo}
          cdkSubscriptionStatus={cdkSubscriptionStatus}
        />
      </PrivateRoute>
      {/* <PrivateRoute
        path={"/cdk-intro-copilot-concept"}
        allowedDivisionAccesses={[
          divisionAccesses.network,
          divisionAccesses.dedicated,
        ]}
      >
        <CDKPromoPageModern
          decodedJWT={decodedClientInfo}
          cdkSubscriptionStatus={cdkSubscriptionStatus}
        />
      </PrivateRoute> */}
      <PrivateRoute
        path={pages.cdkSignUp.url}
        // accessNeeded={featureAccesses.IsCdkClient}
        // accessNeeded={accesses.IsMainAccount} //will move this into a modal or something within the page itself. Don't like it just redirecting and showing a toast.
      >
        <CDKSignupPage2
          decodedJWT={decodedClientInfo}
          cdkSubscriptionStatus={cdkSubscriptionStatus}
          setCDKSubscriptionStatus={setCDKSubscriptionStatus}
        />
      </PrivateRoute>
      {/* <PrivateRoute path="/route-alerts" accessNeeded={accesses.Developer}>
        <RouteAlerts setLoading={setLoadingCallback} />
      </PrivateRoute> */}
      <PrivateRoute path="/invoices" accessNeeded={accesses.Invoice}>
        <Invoices setLoading={setLoadingCallback} />
      </PrivateRoute>
      <PrivateRoute
        path="/view-labels/:id"
        accessNeeded={accesses.Deltrans}
        customersCanAccess
      >
        <LabelViewer setLoading={setLoadingCallback} />
      </PrivateRoute>
      <Route path={pages.trackBarcode.url}>
        <PublicTracker />
      </Route>
      <Route path="/not-found" component={NotFound} />

      {/* END NETWORK PORTAL */}

      {/* DEDICATED PORTAL */}
      <PrivateRoute
        path={pages.dedicatedDispatch.url}
        allowedDivisionAccesses={[divisionAccesses.dedicated]}
        // redirectURL={}
        // accessNeeded={accesses.Dedicated}
      >
        <DedicatedDispatchBoard
          loading={loading}
          setLoading={setLoadingCallback}
          decodedToken={decodedClientInfo}
        />
      </PrivateRoute>

      {/* END DEDICATED PORTAL */}

      {/* <PrivateRoute
        path="/testing-cxthistory"
        accessNeeded={accesses.Developer}
      >
        <CxtHistoryTest />
      </PrivateRoute> */}

      <RedirectOnLogging />
      {/* <Redirect from="/" exact to={pages.mainPage.url} /> */}

      {/* <Redirect to="/not-found" /> */}
    </Switch>
  );
};
